"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedBankAcccountValidation = exports.validationSchema = void 0;
var tslib_1 = require("tslib");
var Yup = (0, tslib_1.__importStar)(require("yup"));
exports.validationSchema = Yup.object().shape({
    accountName: Yup.string()
        .required('Please enter Account name')
        .max(100, 'A name must not exceed 100 characters.')
        .test({
        name: 'name validation',
        message: 'Please enter a name only containing letters. Hyphens and spaces may also be used between names.',
        test: function (name) {
            var nameValue = name || '';
            var nameRegex = /^[a-zA-Z]+([-?\s?'?][a-zA-Z]+)*$/;
            return nameRegex.test(nameValue);
        }
    }),
    bsb: Yup.string()
        .required('Please enter BSB number')
        .test('len', 'Please enter a valid BSB number', function (val, ctx) {
        var bsbValue = val || '';
        var bsbRegex = /^[0-9]{6}$/;
        //return bsbRegex.test(bsbValue) && ctx.parent.isBsbValid !== false && ctx.parent.bank && ctx.parent.branch;
        return bsbRegex.test(bsbValue) && ctx.parent.isBsbValid !== false;
    }),
    accountNumber: Yup.string()
        .required('Please enter account number')
        .test('len', 'Please enter a 6-9 digit account number', function (val) {
        var numValue = val || '';
        var numRegex = /^[0-9]{6,9}$/;
        return numRegex.test(numValue);
    }),
    isAuthorised: Yup.boolean().oneOf([true], 'Need to read and agree')
});
exports.savedBankAcccountValidation = Yup.object().shape({
    savedPaymentId: Yup.string().required()
});
//# sourceMappingURL=BankDetails.validationSchema.js.map